import * as THREE from 'three'
import React, { useMemo, useState } from 'react'

import { const_var, params } from '../../../../../../../../redux/reducers/reducer';

import { delModel, extrudeSettings, wainscotTrimModel } from '../../../../../../../../utils/Functions';
import { CSG } from '../../../../../../../../assets/libs/csg-lib';
import { MaterialTrim, MaterialWainScotTrimNew } from '../../../../../../CustomMaterial';

const TrimModel = () => {
    const textureObj = useMemo(() => {
        const texture = const_var.wallTextureObj?.[params.wallTexture]?.clone();
        const metalTexture = const_var.wallTextureObj?.["vertical"]?.clone();
        const lightTexture = const_var.wallTextureObj?.["vertical_light"]?.clone();
        const wainscotTexture = const_var.wallTextureObj?.[params.wainscotTexture]?.clone();
        
        if(metalTexture){
            if (params.wallOrientation === "vertical") metalTexture.rotation = 0;
            else metalTexture.rotation = Math.PI/-2;
        }
        if(lightTexture) lightTexture.rotation = metalTexture.rotation;
        if(texture && const_var.selSidingOption === "metal") texture.rotation = metalTexture.rotation
        if(wainscotTexture && (params.wainscotTexture === "none" || params.wainscotTexture === "vertical")) wainscotTexture.rotation = metalTexture.rotation

        return {"texture":texture,"wainscotTexture" : wainscotTexture,"metalTexture":metalTexture,"lightTexture":lightTexture};
    }, [params.p_v_w, params.wallTexture, const_var.wallTextureObj, const_var.selSidingOption, params.wallOrientation,params.wainscotTexture]);

    const [sideWallCloseSize, setSideWallCloseSize] = useState(0);
    
    const offsetWithDoorThickness = 0.127;
    const wallThickness = 0.005
    
    const legDistance = useMemo(() => {
        return (const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined) ? const_var.DistanceArr[params.p_b_t][params.p_r_s] : 5
    }, [const_var.DistanceArr, params.p_b_t, params.p_r_s,params.fourth_center_cost,const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined && const_var.DistanceArr[params.p_b_t][params.p_r_s]])

    let offset;
    if(params.leanR_p_d % legDistance === 0) offset = 0.15;
    else offset = 0;
    
    const trimOffset = useMemo(() => {
        if(params.p_b_c_b_r === 'Open') return 0;
        else return 0.2;
    }, [params.p_b_c_b_r])
    
    
    const backWallVrTrimModelTwo = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(params.leanR_p_d / 2 - 0.01, 0);
        model.lineTo(params.leanR_p_d / 2 - 0.01, sideWallCloseSize + trimOffset - 0.1);
        model.lineTo(params.leanR_p_d / 2 + 0.23, sideWallCloseSize + trimOffset - 0.1);
        model.lineTo(params.leanR_p_d / 2 + 0.23, 0);
        model.closePath();

        return model;
    }, [params.add_storage_check_right, sideWallCloseSize, params.p_b_c_b_r_b, params.add_right_back_lean_porch, params.leanR_p_h, params.leanR_p_d, params.p_b_c_b_r, trimOffset])

    const storageFrontWall = useMemo(() => {

        let wainscot;
        let trim;

        const meshStorageFrontWainscotModel = new THREE.Mesh(new THREE.ExtrudeGeometry(wainscotTrimModel(0.14, 0.17), extrudeSettings(params.leanR_p_w - offsetWithDoorThickness + 0.09)))
        const meshFrontStorageDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('rightLeanStorageFront', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'green' }))
        const meshTrimModel = new THREE.Mesh(new THREE.ExtrudeGeometry(backWallVrTrimModelTwo, extrudeSettings(0.22)));
        const meshSideDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('rightLeanSide', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'red' }));

        let meshStorageFrontWainscotModel_Temp = meshStorageFrontWainscotModel.clone();
        meshStorageFrontWainscotModel_Temp.position.set((params.leanR_p_d / 2  - parseInt(params.add_storage_right)) - 0.03, 3, 0.09)
        meshStorageFrontWainscotModel_Temp.rotation.y = Math.PI
        meshStorageFrontWainscotModel_Temp.updateMatrixWorld();

        let meshFrontStorageDelModel_Temp = meshFrontStorageDelModel.clone();
        meshFrontStorageDelModel_Temp.position.set((params.leanR_p_d / 2  - parseInt(params.add_storage_right)) + 0.5, 0, -( params.p_w/2 + params.leanR_p_w - 0.1));
        meshFrontStorageDelModel_Temp.rotation.y = Math.PI/-2
        meshFrontStorageDelModel_Temp.updateMatrixWorld();

        let meshSideDelModel_Temp = meshSideDelModel.clone();
        meshSideDelModel_Temp.position.set(params.rightLeanStoragePosition, 0, -0.15 - params.leanR_p_pos);
        meshSideDelModel_Temp.updateMatrixWorld();

        let meshTrimModel_Temp = meshTrimModel.clone();
        meshTrimModel_Temp.position.set(-parseInt(params.add_storage_right) - 0.1 - offset, 0, -0.03)
        meshTrimModel_Temp.updateMatrixWorld();

        const meshStorageFrontWainscotModel_CSG = CSG.fromMesh(meshStorageFrontWainscotModel_Temp);
        const meshFrontStorageDelModel_CSG = CSG.fromMesh(meshFrontStorageDelModel_Temp);
        const meshSideDelModel_CSG = CSG.fromMesh(meshSideDelModel_Temp);
        const meshTrimModel_CSG = CSG.fromMesh(meshTrimModel_Temp);

        const storagefrontWainscotModel_CSG = meshStorageFrontWainscotModel_CSG.subtract(meshFrontStorageDelModel_CSG);
        const storageSideWallDelModel_CSG = storagefrontWainscotModel_CSG.subtract(meshSideDelModel_CSG);
        const meshTrimDelModel_CSG = meshTrimModel_CSG.subtract(meshSideDelModel_CSG);

        const CSGStorageFrontWainscotModel = CSG.toMesh(storageSideWallDelModel_CSG,new THREE.Matrix4())
        const meshTrimDelModel = CSG.toMesh(meshTrimDelModel_CSG, new THREE.Matrix4());

        wainscot = CSGStorageFrontWainscotModel.geometry;
        trim = meshTrimDelModel.geometry

        return {wainscot, trim}

    }, [params.leanR_p_w, params.leanR_p_d, params.add_storage_right, const_var.newDoorsArray, params.leanR_p_pos, params.rightLeanStoragePosition, backWallVrTrimModelTwo])
    
    // --- side wall set    
    useMemo(() => {
        let tempWallCloseSize = 0;
        if (params.p_b_c_b_r === 'Open' || typeof(params.p_b_c_b_r) === 'object') {
            if (params.p_r_s === 1) {
                tempWallCloseSize = params.leanR_p_h + 0.15;
            } else {
                tempWallCloseSize = params.leanR_p_h;
            }
        } else if (params.p_b_c_b_r === "One_Fourth_Close") {
            tempWallCloseSize = params.leanR_p_h / 4 * 3;
        } else if (params.p_b_c_b_r === "Half_Close") {
            tempWallCloseSize = params.leanR_p_h / 2;
        } else if (params.p_b_c_b_r === "Three_Fourth_Close") {
            tempWallCloseSize = params.leanR_p_h / 4;
        } else if (params.p_b_c_b_r === "Close") {
            tempWallCloseSize = 0;
        } else {
            tempWallCloseSize = params.leanR_p_h - 3 * params.p_b_c_b_r;
        }

        setSideWallCloseSize(tempWallCloseSize);
    }, [params.p_b_c_b_r, params.leanR_p_h, params.p_r_s])
    
    return (
        <group position={[(params.p_w / 2 + params.leanR_p_w - 0.125 + wallThickness), 0, 0]} rotation={[0, Math.PI / 2, 0]}>
            {(params.p_b_c_b_r !== 'Close') && 
                <mesh name="storage-wall-trim" geometry={storageFrontWall.trim}>
                    <MaterialTrim visibleSection={"rightLean"} />
                </mesh>
            }
          
            {params.p_w_c_n == true && storageFrontWall &&
                <mesh name="wainscotTrim" geometry={storageFrontWall.wainscot} position={[-offset, 0, 0]}>
                    <MaterialWainScotTrimNew visibleSection={"rightlean"}/>
                </mesh>
            }
        </group>
    )
}

export default TrimModel